/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectRenewParam
 */
export interface ProjectRenewParam {
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewParam
     */
    title?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectRenewParam
     */
    startDate?: Date;
    /**
     * Only number of month is used
     * @type {string}
     * @memberof ProjectRenewParam
     */
    duration?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewParam
     */
    comment?: string;
}

/**
 * Check if a given object implements the ProjectRenewParam interface.
 */
export function instanceOfProjectRenewParam(value: object): value is ProjectRenewParam {
    return true;
}

export function ProjectRenewParamFromJSON(json: any): ProjectRenewParam {
    return ProjectRenewParamFromJSONTyped(json, false);
}

export function ProjectRenewParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRenewParam {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'duration': json['duration'] == null ? undefined : json['duration'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ProjectRenewParamToJSON(value?: ProjectRenewParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'duration': value['duration'],
        'comment': value['comment'],
    };
}

